export default __webpack_public_path__ + "static/media/CareMsg-min.8685b377.png";